import { RequestStatus } from 'clickNgo/configs/service/common'

import { IPartnerState } from './models'

export const initialState: IPartnerState = {
  partnerData: {
    data: null,
    status: RequestStatus.NONE,
    message: '',
  },
  partnerFiles: {
    data: [],
    status: RequestStatus.NONE,
    message: '',
  },
  partnerFlags: {
    status: RequestStatus.NONE,
    message: '',
    accreditation: [],
    agreement: [],
    program: [],
  },
}

export const GET_PARTNER_BY_ID_REQUEST = 'partner/getPartnerById'
export const GET_NEW_PARTNER_BY_ID_REQUEST = 'partner/getNewPartnerById'

export const GET_PARTNER_ACCREDITATION_CODES_BY_ID_REQUEST =
  'partner/getPartnerAccreditationCodesById'
export const GET_PARTNER_PROGRAM_CODES_BY_ID_REQUEST = 'partner/getPartnerProgramCodesById'
export const GET_PARTNER_FLAGS_BY_ID_REQUEST = 'partner/getPartnerFlagsById'
export const GET_PARTNER_FILES_BY_ID_REQUEST = 'partner/getPartnerFilesById'
export const UPDATE_PARTNER_FILES = 'updatePartnerFiles'
